import {useApiFetch} from '~/api/useApiFetch';

// Create the abort controller
let controller = null;

if (process.client) {
  controller = new AbortController();
}

const apiFetch = useApiFetch();

export default {
  cancelRequests() {
    if (process.client && controller) {
      // Abort requests
      controller.abort();

      // Create new abort controller
      controller = new AbortController();
    }
  },

  async getCoreData() {
    try {
      const data = await apiFetch('plugin-store/core-data',{
        signal: controller ? controller.signal : undefined,
      });
      return {data};
    } catch (error) {
      if (error.name === 'AbortError') {
        // request cancelled
        return;
      }
      throw error;
    }
  },

  async getDeveloperBySlug(slug) {
    try {
      const data = await apiFetch(`developer/${slug}`, {
        signal: controller ? controller.signal : undefined,
      });
      return {data};
    } catch (error) {
      if (error.name === 'AbortError') {
        // request cancelled
        return;
      }
      throw error;
    }
  },

  async getFeaturedSectionByHandle(featuredSectionHandle) {
    try {
      const data = await apiFetch(`plugin-store/featured-section/${featuredSectionHandle}`, {
        signal: controller ? controller.signal : undefined,
      });
      return {data};
    } catch (error) {
      if (error.name === 'AbortError') {
        // request cancelled
        return;
      }
      throw error;
    }
  },

  async getFeaturedSections({cmsConstraint}) {
    try {
      const data = await apiFetch('plugin-store/featured-sections', {
        signal: controller ? controller.signal : undefined,
        params: {
          cmsConstraint,
        },
      });
      return {data};
    } catch (error) {
      if (error.name === 'AbortError') {
        // request cancelled
        return;
      }
      throw error;
    }
  },

  async getPluginChangelog({cmsConstraint, pluginId}) {
    try {
      const data = await apiFetch(`plugin/${pluginId}/changelog`, {
        signal: controller ? controller.signal : undefined,
        params: {
          cmsConstraint,
        },
      });

      if (data && data.error && data.error === "Couldn't find plugin") {
        // The plugin changelog hasn't been found using the `cmsConstraint`, try again without
        try {
          const retryData = await apiFetch(`plugin/${pluginId}/changelog`, {
            signal: controller ? controller.signal : undefined,
          });
          return {data: retryData};
        } catch (retryError) {
          if (retryError.name === 'AbortError') {
            // request cancelled
            return;
          }
          throw retryError;
        }
      }
      return {data};
    } catch (error) {
      if (error.name === 'AbortError') {
        // request cancelled
        return;
      }
      throw error;
    }
  },

  async getPluginDetails(pluginId) {
    try {
      const data = await apiFetch(`plugin/${pluginId}`, {
        signal: controller ? controller.signal : undefined,
      });
      return {data};
    } catch (error) {
      if (error.name === 'AbortError') {
        // request cancelled
        return;
      }
      throw error;
    }
  },

  async getPluginDetailsByHandle({cmsConstraint, pluginHandle}) {
    try {
      const data = await apiFetch(`plugin-store/plugin/${pluginHandle}`, {
        signal: controller ? controller.signal : undefined,
        params: {
          cmsConstraint,
          withInstallHistory: true,
          withIssueStats: true,
          withReviewStats: true,
        },
      });

      if (data && data.error && data.error === "Couldn't find plugin") {
        // The plugin details haven't been found using the `cmsConstraint`, try again without
        try {
          const retryData = await apiFetch(`plugin-store/plugin/${pluginHandle}`, {
            signal: controller ? controller.signal : undefined,
            params: {
              withInstallHistory: true,
              withIssueStats: true,
            },
          });
          return {data: retryData};
        } catch (retryError) {
          if (retryError.name === 'AbortError') {
            // request cancelled
            return;
          }
          throw retryError;
        }
      }
      return {data};
    } catch (error) {
      if (error.name === 'AbortError') {
        // request cancelled
        return;
      }
      throw error;
    }
  },
};
